(function(){
  function ensureReserveAnchor(){
    if (document.getElementById('nbn-reserve-container')) return true;
    var addButton = document.getElementById('AddToCart');
    if (!addButton) return false;
    var reserve = document.createElement('div');
    reserve.id = 'nbn-reserve-container';
    reserve.style.marginTop = '8px';
    addButton.insertAdjacentElement('afterend', reserve);
    return true;
  }
  function loadWidget(){
    ensureReserveAnchor();
    if (document.getElementById('nbn-reserve-toggle')) return;
    if (document.getElementById('nbn-reserve-widget-refresh')) return;
    var script = document.createElement('script');
    script.id = 'nbn-reserve-widget-refresh';
    script.src = 'https://cdn.shopify.com/s/files/1/0579/7258/8717/t/33/assets/nbn-widget.js?v=1792138025';
    script.defer = true;
    document.head.appendChild(script);
  }
  function init(){
    loadWidget();
    [300,800,1600,3000,5000].forEach(function(ms){ setTimeout(loadWidget, ms); });
    new MutationObserver(loadWidget).observe(document.body, {childList:true, subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
